import Reviews from './Reviews.vue';

export default Reviews;



// WEBPACK FOOTER //
// ./src/components/parts/reviews/index.ts